import estadisticasMensualFormModel from './estadisticasMensualFormModel';

const {
  formField: { nombre_cliente, startDate, endDate },
} = estadisticasMensualFormModel;

export default {
  [nombre_cliente.name]: undefined,
  [startDate.name]: '',
  [endDate.name]: '',
};
